import React, { useEffect } from 'react';
import heroLogo from '../../assets/home/Hero/HeroLogo.svg';


function HomeHero() {
  useEffect(() => {
    // Hero is hidden on mobile via CSS — skip expensive bubble DOM work
    if (window.innerWidth < 992) return;

    const $bubbles = document.querySelector('.bubbles');

    function bubbles() {
      // Clear existing bubbles
      $bubbles.innerHTML = '';

      // Enhanced settings
      const min_bubble_count = 25,
        max_bubble_count = 40,
        min_bubble_size = 8,
        max_bubble_size = 70;

      // Calculate a random number of bubbles
      const bubbleCount =
        min_bubble_count + Math.floor(Math.random() * (max_bubble_count - min_bubble_count));

      // Bubble types for variety
      const bubbleTypes = ['bubble-type-1', 'bubble-type-2', 'bubble-type-3', 'bubble-type-glow'];
      const wobbleTypes = ['wobble-1', 'wobble-2', 'wobble-3'];

      // Create the bubbles
      for (let i = 0; i < bubbleCount; i++) {
        const bubbleType = bubbleTypes[Math.floor(Math.random() * bubbleTypes.length)];
        const wobbleType = wobbleTypes[Math.floor(Math.random() * wobbleTypes.length)];
        
        $bubbles.innerHTML += `
          <div class="bubble-container ${wobbleType}">
            <div class="bubble ${bubbleType}"></div>
          </div>`;
      }

      // Now randomize the various bubble elements
      $bubbles.querySelectorAll('.bubble-container').forEach((bubbleContainer) => {
        const pos_rand = Math.floor(Math.random() * 100);
        const size_rand =
          min_bubble_size + Math.floor(Math.random() * (max_bubble_size - min_bubble_size + 1));
        const delay_rand = Math.random() * 8;
        const speed_rand = 6 + Math.random() * 10;
        const blur_rand = Math.random() * 0.8;
        const opacity_rand = 0.3 + Math.random() * 0.7;
        
        // Add slight horizontal drift
        const drift_rand = -15 + Math.random() * 30;

        bubbleContainer.style.left = pos_rand + '%';
        bubbleContainer.style.animationDuration = speed_rand + 's';
        bubbleContainer.style.animationDelay = delay_rand + 's';
        bubbleContainer.style.setProperty('--drift-amount', `${drift_rand}px`);

        const bubble = bubbleContainer.querySelector('.bubble');
        bubble.style.width = size_rand + 'px';
        bubble.style.height = size_rand + 'px';
        bubble.style.opacity = opacity_rand;
        
        // Only apply blur to larger bubbles for depth
        if (size_rand > 40) {
          bubbleContainer.style.filter = `blur(${blur_rand}px)`;
        }
      });
    }

    // Initial call to bubbles function
    bubbles();
  }, []); // Empty dependency array ensures the useEffect runs once on mount

  return (
    <>
      <div id="homeHeroWrapper">
        <img id='homeHeroLogo' src={heroLogo} alt="logo Fervent Ferment" />
        <div className='bubbles'></div>
      </div>
    </>
  );
}

export default HomeHero;
